//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteBlockType, CustomFieldType } from './Enums';

export class WebsiteCustomFieldSearchOptions extends ItemBase {
    IDs: string[] = [];
    WebsiteBlockIDs: string[] = [];
    WebsiteBlockTypes: WebsiteBlockType[] = [];
    FieldTypes: CustomFieldType[] = [];

    constructor(initializer?: Partial<WebsiteCustomFieldSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteCustomFieldSearchOptions";
}
